function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, reactive, onMounted, toRefs, computed, watch, getCurrentInstance } from "vue";
import searchMixin from "@/mixin/search";
import SearchBar from "@/components/SearchV3/index.vue";
import TableList from "@/components/TableList/index.vue";
import { formItemConfig, tableColumnConfig, queryConfig, refreshSearchQuery } from "./authorization-option";
import Pagination from "@/components/Pagination/index.vue";
import AuthorizationDialog from "./components/authorization-dialog.vue";
import AuthorizationTableDialog from "./components/authorization-table-dialog.vue";
import { fetchICSAdvertiserList, icsAdvertiserDownload } from "@/api/ics_advertiser/manage";
export default defineComponent({
    components: {
        SearchBar: SearchBar,
        TableList: TableList,
        Pagination: Pagination,
        AuthorizationDialog: AuthorizationDialog,
        AuthorizationTableDialog: AuthorizationTableDialog
    },
    mixins: [
        searchMixin
    ],
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var btnTitle = ref("\u65B0\u589E\u6388\u6743");
        var exportLoading = ref(false);
        var formItemList = reactive(formItemConfig);
        var searchQuery = reactive({
            query: queryConfig
        });
        /* 授权信息表格 */ var accountTable = reactive({
            accountTableColumn: tableColumnConfig,
            accountList: [],
            accountListTotal: 0,
            listLoading: false,
            formItemInfo: {}
        });
        var createConfig = reactive({
            visible: false,
            action: "create"
        });
        var tableConfig = reactive({
            visible: false,
            action: "history",
            accountId: 0
        });
        var exportButtonAttrs = computed(function() {
            return {
                icon: "el-icon-fa-download",
                type: "primary"
            };
        });
        onMounted(function() {
            watch(function() {
                return root.$route;
            }, function() {
                refreshSearchQuery(searchQuery.query) // 处理路由数据格式问题
                ;
                // eslint-disable-next-line no-use-before-define
                getAdvertiserList(searchQuery.query);
            }, {
                immediate: true
            });
        });
        var getAdvertiserList = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            accountTable.listLoading = true;
                            _ctx.next = 3;
                            return fetchICSAdvertiserList(data);
                        case 3:
                            res = _ctx.sent;
                            accountTable.accountList = res.data.data.list;
                            accountTable.accountListTotal = res.data.data.total;
                            accountTable.listLoading = false;
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getAdvertiserList(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var openAuthorizationDialog = function() {
            accountTable.formItemInfo = {};
            createConfig.action = "create";
            createConfig.visible = true;
        };
        var editAuthorizationDialog = function(row) {
            accountTable.formItemInfo = row;
            createConfig.action = "update";
            createConfig.visible = true;
        };
        var viewAuthorizationDialog = function(row, type) {
            tableConfig.accountId = row.ssUid;
            tableConfig.action = type;
            tableConfig.visible = true;
        };
        var updateAuthorizationList = function() {
            getAdvertiserList(searchQuery.query);
        };
        var exportSheet = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            exportLoading.value = true;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return icsAdvertiserDownload(searchQuery.query);
                        case 4:
                            res = _ctx.sent;
                            exportLoading.value = false;
                            window.open(res.data.data, "_blank");
                            _ctx.next = 13;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](1);
                            exportLoading.value = false;
                            console.log(_ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        9
                    ]
                ]);
            }));
            return function exportSheet() {
                return _ref.apply(this, arguments);
            };
        }();
        return _objectSpreadProps(_objectSpread({}, toRefs(searchQuery)), {
            exportLoading: exportLoading,
            accountTable: accountTable,
            createConfig: createConfig,
            tableConfig: tableConfig,
            btnTitle: btnTitle,
            formItemList: formItemList,
            exportButtonAttrs: exportButtonAttrs,
            exportSheet: exportSheet,
            openAuthorizationDialog: openAuthorizationDialog,
            editAuthorizationDialog: editAuthorizationDialog,
            viewAuthorizationDialog: viewAuthorizationDialog,
            updateAuthorizationList: updateAuthorizationList
        });
    }
});
